import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="reset-form"
export default class extends Controller {
  validateBeforeSubmit = (event) => {
    const textarea = this.element.querySelector(".tinymce-editor")

    if (textarea && typeof tinymce !== "undefined") {
      const editor = tinymce.get(textarea.id)

      if (editor && editor.getContent().trim() === "") {
        alert("Bitte geben Sie eine Nachricht ein!")

        // Prevent the form submission (Turbo-specific)
        event.detail.formSubmission.stop()
      }
    }
  }


  reset = (event) => {
    if (event.detail.success) {
      const textareas = this.element.querySelectorAll(".tinymce-editor")

      textareas.forEach((textarea) => {
        if (textarea.id && typeof tinymce !== "undefined") {
          const editor = tinymce.get(textarea.id)
          if (editor) editor.setContent("")
        }
      })

      const checkbox = this.element.querySelector("#messaging_message_send_multiple")
      if (checkbox) checkbox.checked = false
    }
  }
}
